<template>
  <div>
    <div v-if="column">
      {{column.title | normalize}}

      <div v-html="column.content" />

      <div class="text-center">
        <router-link tag="button" class="btn btn-sm btn-secondary" :to="{name:'columnEdit', params: {id: column.id}}">Edit</router-link>
        <button type="button" class="btn btn-sm btn-secondary" @click="$router.back()">List</button>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'AdminCaseView',
  data() {
    return {
      column: null,
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.axios.get(`/admin/media/column/${this.$route.params.id}`)
        .then(({ data }) => {
          this.column = data;
        });
    }
  },
};
</script>

<style scoped>

</style>
